import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "companies";

export const GET_COMPANIES = "getCompanies";
export const GET_COMPANIES_OPTIONS = "getCompaniesOptions";
export const GET_COMPANY_TYPES_OPTIONS = "getCompanyTypesOptions";
export const GET_COMPANY_RANKS_OPTIONS = "getCompanyRanksOptions";
export const GET_COMPANY = "getCompany";
export const CREATE_COMPANY = "createCompany";
export const UPDATE_COMPANY = "updateCompany";
export const DELETE_COMPANY = "deleteCompany";
export const GET_COMPANY_ADDRESSES = "getCompanyAddresses";
export const CREATE_COMPANY_ADDRESS = "createCompanyAddress";
export const UPDATE_COMPANY_ADDRESS = "updateCompanyAddress";
export const DELETE_COMPANY_ADDRESS = "deleteCompanyAddress";

const state = {
  //
};

const getters = {
  //
};

const actions = {
  [GET_COMPANIES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_COMPANIES_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_COMPANY_TYPES_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("companyTypes/options", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_COMPANY_RANKS_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("companyRanks/options", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_COMPANY](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [CREATE_COMPANY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [UPDATE_COMPANY](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_COMPANY_ADDRESSES](context, companyId) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, `${companyId}/addresses`)
        .then(({ data }) => resolve(data.data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_COMPANY_ADDRESS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.companyId}/addresses`, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_COMPANY_ADDRESS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${PATH}/${payload.companyId}/addresses/${payload.id}`, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_COMPANY_ADDRESS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.companyId}/addresses/${payload.id}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_COMPANY](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

const mutations = {
  //
};

export default {
  state,
  actions,
  mutations,
  getters,
};
